import { can } from "@/plugins/can";

import DisciplinasIndexPage from "@/Pages/Disciplinas/index.vue";
import NewEditDisciplinaPage from "@/Pages/Disciplinas/NewEditDisciplinaPage.vue";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/disciplinas/",
    name: "disciplinas",
    component: DisciplinasIndexPage,
    beforeEnter: checkPermission(["users.*"]),
  },
  {
    path: "/disciplinas/create",
    name: "disciplinas.create",
    component: NewEditDisciplinaPage,
    props: { editing: false },
    beforeEnter: checkPermission(["users.*"]),
  },
  {
    path: "/disciplinas/edit/:disciplina_id",
    name: "disciplinas.edit",
    component: NewEditDisciplinaPage,
    props: { editing: true },
    beforeEnter: checkPermission(["users.*"]),
  },
];
